import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { ManufacturerInfo } from '../fragments';

export default gql`
  mutation updateManufacturer($input: ManufacturerUpdateInput!) {
    updateManufacturer(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      manufacturer {
        ...ManufacturerInfo
      }
    }
  }
  ${ManufacturerInfo}
  ${ErrorMessageInfo}
`;
